export default "__VITE_ASSET__ayCh5XIk__"